import React, { useEffect } from "react";
import { useState } from "react";
import Education from "./Sections/Education/Education";
import Experience from "./Sections/Experience/Experience";
import Programming from "./Sections/Programming/Programming";
import Projects from "./Sections/Projects/Projects";
import Achivments from "./Sections/Achivments/Achivments";
import "./Resume.css";

const Action = {
  EDU: "Education",
  EXP: "Experience",
  PRG: "Programming Skills",
  PRO: "Projects",
  ACV: "Achivments",
};

export default function Resume() {
  const [card, setCard] = useState(<Education />);
  const [tarnsition, setTransition] = useState("");
  const [selectedAction, setSelectedAction] = useState(Action.EDU);
  function cardFunc(actions) {
    setSelectedAction(actions);
    setTransition("fade-out");
    setTimeout(() => {
      switch (actions) {
        case Action.EDU:
          setCard(<Education />);
          break;
        case Action.EXP:
          setCard(<Experience />);
          break;
        case Action.PRG:
          setCard(<Programming />);
          break;
        case Action.PRO:
          setCard(<Projects />);
          break;
        case Action.ACV:
          setCard(<Achivments />);
          break;
        default:
          break;
      }
    }, 500);
  }

  useEffect(() => {
    //const timeout = setTimeout(() => {
    setTransition("");
    //  }, 500); // 500ms, same as the CSS transition duration
    //return () => clearTimeout(timeout);
  }, [card]);

  return (
    <div>
      <div id="Resume" className="resume-container">
        <div className="header-container">
          {" "}
          <h2>
            <span className="primary-text">Resume</span>
          </h2>{" "}
          <span style={{ color: "grey" }}>My Bio Details</span>
          <span> &#8594; &#9827; &#8592;</span>
        </div>
        <div className="resume-box">
          <div className="resume-sidebar">
            <ul>
              <li>👨🏽‍🎓</li>
              <li>⌛</li>
              <li>💻</li>
              <li>📊</li>
              <li>🎨</li>
            </ul>
          </div>
          <div className="resume-catagory">
            <ul>
              <li
                onClick={() => {
                  cardFunc(Action.EDU);
                }}
                className={selectedAction === Action.EDU ? "active" : ""}
              >
                Education
              </li>
              <li
                onClick={() => {
                  cardFunc(Action.EXP);
                }}
                className={selectedAction === Action.EXP ? "active" : ""}
              >
                Experience
              </li>
              <li
                onClick={() => {
                  cardFunc(Action.PRG);
                }}
                className={selectedAction === Action.PRG ? "active" : ""}
              >
                Programming Skills
              </li>
              <li
                onClick={() => {
                  cardFunc(Action.PRO);
                }}
                className={selectedAction === Action.PRO ? "active" : ""}
              >
                Projects
              </li>
              <li
                onClick={() => {
                  cardFunc(Action.ACV);
                }}
                className={selectedAction === Action.ACV ? "active" : ""}
              >
                Interest
              </li>
            </ul>
          </div>
          <div className={`resume-cards ${tarnsition}`}>{card}</div>
        </div>
      </div>
    </div>
  );
}
